import React, { Component } from 'react';
import { message } from "antd";
import Footer from '../../components/Footer';
import Nav from '../../components/Nav/index';
import Loader from '../../components/loader';
import Slider from "react-slick";
import $ from 'jquery';
import Utils from '../../utils/utils';
import './index.less';
import anime from 'animejs';
import img1 from '../../assets/img/img1.png';
import img2 from '../../assets/img/img2.png';
import Axios from "../../axios";
const rdom = require('react-dom');
export default class Case extends Component{
    state={
        isLoading:true,
        marginLeft:0,
        ulWidth:'1200%',
    }
    componentWillMount() {
        this.caseRequest();//获取案例
    }
    componentDidMount(){
        let slidesli0 = document.getElementById('slidesli0');
        if(slidesli0){
            console.log(slidesli0,'slidesli0slidesli0')
            let ulWidth = document.getElementById('slidesli0').offsetWidth*this.state.caseItems.length;
            // this.setState({
            //     ulWidth,
            // })
        }
    }
    animation = () =>{
        // var textWrapper = document.querySelector('.title');
        // textWrapper.innerHTML = textWrapper.textContent.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");
        // anime.timeline({loop: 1})
        //     .add({
        //         targets: '.letter',
        //         opacity: [0,1],
        //         translateY: ['-5vh',0],
        //         easing: "easeInExpo",
        //         duration: 300,
        //         delay: function(el, i) {
        //             return 10 * i;
        //         }
        //     })
            // .add({
            //     targets: '.slide-box',
            //     opacity: [0,1],
            //     translateY: ['28vh',0],
            //     duration: 1000,
            //     easing: "easeInExpo",
            //     // delay: 1000
            // })
            // .add({
            //     targets: '.title',
            //     opacity: [0.8,1],
            //     duration: 1000,
            //     easing: "easeInExpo",
            //     delay: 750
            // })
    }
    /*列表数据请求*/
    caseRequest = () => {
        let  _this = this;
        var params = {type:"Case"};
        this.setState({
            isLoading: true,
        })
        Axios.post({
            block: '/api',
            url: '/post',
            params: params,
        }).then((data) => {
            if(data.code === 0){
                let caseItems = [];
                let items = data.data;
                for(let i in items){
                    let item = items[i].post;
                    item.isActive = false;
                    if(i==0){
                        item.isActive = true;
                        this.setState({
                            description:item.description,
                            title:item.title
                        })
                    }
                    caseItems.push(item);
                }
                this.setState({
                    caseItems
                })
            }else{
                console.log(data.msg)
                message.error(data.msg)
            }
            // this.setState({
            //     isLoading: false
            // })
            setTimeout(function () {
                _this.setState({
                    isLoading: false
                })
            },1000)
            this.animation();
        }).catch((error) => {
            console.log(error);
        })
    };
    //鼠标滚动
    handleScroll=(e)=> {
        const ele = rdom.findDOMNode(this);
        var scrollDiv = document.getElementById("scrollDiv");
        let slides = document.getElementById("slides");
        let scrollDivWidth = scrollDiv.offsetWidth;
        let ulWidth = document.getElementById('slidesli0').offsetWidth*this.state.caseItems.length;
        const scrollTop = (e.srcElement ? e.srcElement.documentElement.scrollTop : false)
            || window.pageYOffset
            || (e.srcElement ? e.srcElement.body.scrollTop : 0);
        const clientHeight = (e.srcElement ? e.srcElement.documentElement.clientHeight : false)
            ||window.innerHeight
            || (e.srcElement ? e.srcElement.body.clientHeight : 0);
        let marginLeft = this.state.marginLeft;
        if (e.nativeEvent.deltaY < 0) {
            // e.preventDefault();
            // if(scrollDivWidth)
            marginLeft+=200;
            if(marginLeft>0){
                marginLeft = 0;
            }
            slides.style.marginLeft = marginLeft +'px';
        } else {
            /* scrolling down */
            marginLeft-=200;
            if(marginLeft<-(ulWidth-scrollDivWidth)){
                marginLeft = -(ulWidth-scrollDivWidth);
            }
            slides.style.marginLeft = marginLeft +'px';
            // if(!this.state.isShow){
            //     anime.timeline({loop: 1})
            //         .add({
            //             targets: '.team-exp',
            //             translateX: [-150,0],
            //             opacity: [0,1],
            //             easing: "easeInExpo",
            //             duration: 1000
            //         })
            //         .add({
            //             targets: '.team-avar',
            //             translateX: [100,0],
            //             opacity: [0,1],
            //             easing: "easeInExpo",
            //             duration: 1000
            //         })
            //     this.setState({
            //         isShow:true
            //     })
            // }
        }
        this.setState({
            marginLeft
        })
    }
    //点击
    clickItem = (e,id) => {
        let caseItems = this.state.caseItems;
        console.log($(".txt-tip"))
        $(".txt-tip").removeClass('txt-active');
        $(".txt-tip").addClass('txt-active');
        // $(".txt-tip").removeClass('animation', 'fade-in 4s ease 0s 1');
        caseItems.map((item,index)=>{
            item.isActive=false;
            if(item.id === id){
                item.isActive=true;
                this.setState({
                    description:item.description,
                    title:item.title
                })
            }
        })
        // anime.timeline({loop: 1})
        // .add({
        //     targets: '.txt-tip',
        //     opacity: [0,1],
        //     duration: 1000,
        //     easing: "easeInOutExpo",
        // })
    }
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1
        };
        const { caseItems, description, title, isLoading,ulWidth } = this.state;
        // console.log(isLoading)
        return (
            <div >
                {
                    isLoading?<Loader cTitle="案例" eTitle="CASE"/>
                    :<div className="case-box">
                            <div className="case-contain">
                                {/*<h4 className="title">mature cases</h4>*/}
                                <div className="flexslider slider--team-thumbs" id="scrollDiv" style={{maxWidth: 1250+'px',margin:'auto'}}onWheel={(e) => this.handleScroll(e)}>
                                    {/* <div className="flex-viewport" style={{overflow: 'hidden', position: 'relative'}}> */}
                                        <ul className="slides" id='slides' ref="slides" style={{width: ulWidth,transitionDuration: '0s',transform: 'translate3d(0px, 0px, 0px)'}}>
                                            {
                                                caseItems?caseItems.map((item,index)=>{
                                                    return (
                                                        <li key={index} id={'slidesli'+index} style={{float: 'left', display: 'block'}}
                                                            className={item.isActive?"flex-active-slide":""} onClick={e=>this.clickItem(e,item.id)}>
                                                            {/*<img src={Utils.getUrl(item.thumbnail)}/>*/}
                                                            <div className="table" style={{backgroundImage:"url("+Utils.getUrl(item.thumbnail)+")"}}>
                                                                <div className="table__cell slide__inner">
                                                                    {/*<h3 className="flat">{item.title}</h3>*/}
                                                                    {/*<small>{item.description}</small>*/}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )
                                                }):''
                                            }
                                        </ul>
                                    {/* </div> */}
                                </div>
                                {/*<div className="slide-box" onWheel={(e) => this.handleScroll(e)}>*/}
                                {/*    */}
                                {/*</div>*/}
                                {/*<div className="txt-tip" style={{opacity:'1'}}>*/}
                                {/*    <h4>{title}</h4>*/}
                                {/*    <p>{description}</p>*/}
                                {/*</div>*/}
                                <ul className="slides-tips">
                                    {
                                        caseItems?caseItems.map((item,index)=>{
                                            return (
                                                <li key={index} className={item.isActive?"txt-active":""}>
                                                    <div className="txt-tip">
                                                        <h4>{item.title}</h4>
                                                        <p>{item.description}</p>
                                                    </div>
                                                </li>
                                            )
                                        }):''
                                    }
                                </ul>
                            </div>
                            <Footer/>
                            {/*<Nav isShow={true}/>*/}
                        </div>
                }

            </div>
        )
    }

}
